import React, { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

// Premium loading animation: brand monogram + wipe reveal.
export const Loader = ({ onDone }) => {
  const [show, setShow] = useState(true);
  const onDoneRef = useRef(onDone);
  onDoneRef.current = onDone;

  useEffect(() => {
    const t = setTimeout(() => {
      setShow(false);
      onDoneRef.current && onDoneRef.current();
    }, 850);
    return () => clearTimeout(t);
  }, []);

  const word = "ANKITA GOGIA";

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed inset-0 z-[10000] flex items-center justify-center bg-charcoal"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
          data-testid="page-loader"
        >
          <div className="overflow-hidden">
            <motion.div
              className="flex gap-[0.05em] font-heading text-cream text-3xl md:text-5xl tracking-tight"
              initial="hidden"
              animate="show"
              variants={{ show: { transition: { staggerChildren: 0.045, delayChildren: 0.15 } } }}
            >
              {word.split("").map((ch, i) => (
                <motion.span
                  key={i}
                  variants={{
                    hidden: { y: "110%", opacity: 0 },
                    show: { y: "0%", opacity: 1, transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } },
                  }}
                  className={ch === " " ? "w-3 md:w-5" : ""}
                >
                  {ch === " " ? "\u00A0" : ch}
                </motion.span>
              ))}
            </motion.div>
            <motion.div
              className="mt-4 h-[2px] bg-gold origin-left"
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
